export type CarouselSlideWithPlatformPostId = {
    platformPostId?: string | null;
};

export const getCarouselSlideNumber = (
    platformPostId?: string | null,
): number | null => {
    const match = platformPostId?.match(/\|(\d+)$/);
    return match ? Number(match[1]) : null;
};

export const getCarouselSlideLabel = (
    slide: CarouselSlideWithPlatformPostId,
    fallbackIndex: number,
) => `Slide ${getCarouselSlideNumber(slide?.platformPostId) ?? fallbackIndex + 1}`;

export const sortCarouselSlidesBySlideNumber = <
    T extends CarouselSlideWithPlatformPostId,
>(
    slides: T[],
): T[] => {
    const slideNumbers = slides.map(slide =>
        getCarouselSlideNumber(slide?.platformPostId),
    );

    if (
        !slideNumbers.length ||
        slideNumbers.some(slideNumber => slideNumber === null)
    ) {
        return slides;
    }

    return [...slides].sort(
        (a, b) =>
            (getCarouselSlideNumber(a?.platformPostId) ?? 0) -
            (getCarouselSlideNumber(b?.platformPostId) ?? 0),
    );
};
